export const CREATE_SHIPMENTS_USER_PERMISSION = 'shipments.create_shipments';
export const CREATE_ORDERS_USER_PERMISSION = 'orders.create_orders';
export const CREATE_QUOTES_USER_PERMISSION = 'quotes.create_quotes';
